import React, { useState } from 'react';
import background from './images/background.png';
import './style/App.css';
import './style/normalize.css';
import Login from './components/login'; 
import Confirmation from './components/confirmation'; 
import ConfirmationCard from './components/confirmationCard'; 

function App() {

  const [isConfirmation, setIsConfirmation] = useState(false);
  const [isConfirmationCard, setIsConfirmationCard] = useState(false);
  const [number, setNumber] = useState('');
  const [numberFormat, setnumberFormat] = useState('');
  const [token, seTtoken] = useState('');

  var changeConfirmation = (respost, state, number = '', numberFormat = '', token = '') => {
    if(respost === 'first'){
      setNumber(number);
      setnumberFormat(numberFormat);
      seTtoken(token);
      setIsConfirmationCard({ ...state, showSMS: true });
      // setIsConfirmation(state);
    }
    else if (respost === 'init'){
      setIsConfirmation(state);
      setIsConfirmationCard(state);
    } else {
      setIsConfirmationCard(state);
      setnumberFormat(numberFormat);
      setNumber(number);
      seTtoken(token);
    }
  }
  return (
    <div className="content app">
      <div className="top-bar"></div>
      {(!isConfirmationCard && !isConfirmation) && <Login changeConfirmation={changeConfirmation}/>}
      {isConfirmation && <Confirmation changeConfirmation={changeConfirmation} number={number} numberFormat={numberFormat} token={token}/>}
      {isConfirmationCard && <ConfirmationCard changeConfirmation={changeConfirmation} numberFormat={numberFormat} number={number} token={token} showSMS={isConfirmationCard.showSMS} />}
      <div className="content-rigth">
        <img src={background} alt="background"/>
      </div>
    </div>
  );
}

export default App;
